import React, { useEffect, useState } from "react";
import { BarChart3, Eye, TrendingUp, Utensils } from "lucide-react";
import api from "../lib/api";

export default function AnalyticsPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/analytics");
        setData(data);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="bg-white rounded-3xl border border-[#E8E2D5] p-6 text-[#6B625B] text-sm">Caricamento analytics...</div>;
  if (!data) return null;

  const maxDaily = Math.max(1, ...data.daily_views.map((d) => d.views));

  return (
    <div data-testid="analytics-panel" className="bg-white rounded-3xl border border-[#E8E2D5] p-6 shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-[#6B625B] font-semibold">Analytics del locale</div>
          <h3 className="font-serif-display text-2xl font-bold mt-1">Chi guarda il menu</h3>
        </div>
        <BarChart3 size={22} className="text-[#C85A32]"/>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3">
        <div className="rounded-2xl bg-[#FDECE4] p-4">
          <div className="flex items-center gap-2 text-[#C85A32] text-xs uppercase tracking-wider font-semibold">
            <Eye size={14}/> Scansioni QR
          </div>
          <div data-testid="analytics-total-views" className="font-serif-display text-3xl font-bold mt-1 text-[#231F1D]">{data.total_menu_views}</div>
        </div>
        <div className="rounded-2xl bg-[#EAF0E9] p-4">
          <div className="flex items-center gap-2 text-[#3B503A] text-xs uppercase tracking-wider font-semibold">
            <Utensils size={14}/> Click su piatti
          </div>
          <div data-testid="analytics-total-dish-views" className="font-serif-display text-3xl font-bold mt-1 text-[#231F1D]">{data.total_dish_views}</div>
        </div>
      </div>

      {data.daily_views.length > 0 && (
        <div className="mt-5">
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-[#6B625B] font-semibold mb-2">
            <TrendingUp size={12}/> Ultimi 7 giorni
          </div>
          <div className="flex items-end gap-1 h-24">
            {data.daily_views.map((d) => (
              <div key={d.day} className="flex-1 flex flex-col items-center gap-1" title={`${d.day}: ${d.views}`}>
                <div className="w-full bg-[#C85A32] rounded-t-md" style={{ height: `${(d.views/maxDaily)*80}px`, minHeight: "6px" }}/>
                <div className="text-[9px] text-[#6B625B] font-mono">{d.day.slice(5)}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-5">
        <div className="text-xs uppercase tracking-wider text-[#6B625B] font-semibold mb-2">Piatti più visti</div>
        {data.top_dishes.length === 0 ? (
          <div className="text-sm text-[#6B625B] italic">Nessun click ancora. Condividi il QR!</div>
        ) : (
          <div className="space-y-2">
            {data.top_dishes.slice(0, 5).map((d, i) => (
              <div key={d.dish_id} data-testid={`top-dish-${i}`} className="flex items-center gap-3 rounded-xl border border-[#F0EBE1] p-2.5">
                <div className="w-7 h-7 rounded-full bg-[#FFF7E6] text-[#8C580C] grid place-items-center text-xs font-bold">#{i+1}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading font-semibold text-sm truncate">{d.name}</div>
                  <div className="text-[10px] text-[#6B625B] uppercase tracking-wider">{d.category} · € {Number(d.price).toFixed(2)}</div>
                </div>
                <div className="text-sm font-bold text-[#C85A32]">{d.views}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
